export type CardEventType =
  | 'save_contact' | 'click_email' | 'click_phone' | 'click_route' | 'click_link' | 'click_social'
  | 'send_whatsapp' | 'send_email' | 'send_call' | 'show_qr';

/**
 * Report what a visitor did on a public card (anonymous, fire and forget).
 * Only runs on cards served by the API (they carry a short code), never in the editor preview.
 */
export function trackCardEvent(shortCode: string | null | undefined, type: CardEventType, target?: string): void {
  if (!shortCode || typeof window === 'undefined') return;
  try {
    void fetch(`/api/public/card/short/${encodeURIComponent(shortCode)}/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, target }),
      keepalive: true,
      credentials: 'include',
    }).catch(() => undefined);
  } catch {
    /* tracking must never break the card */
  }
}
